import axios from "axios";
import { APIURL } from "../config";

const AddDocumentTransactionAPI = async (data) => {
  const url = APIURL + "/schema/adddocumenttransaction";
  return await axios.post(url, data);
};

export default AddDocumentTransactionAPI;
